import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import dotProductCommons from './commons/dot_product.js'

const level = new Level({
    name: 'dot_product_geo',
    dependencies: [
        'levels_maths/dot_product_with_unit',
        'levels_maths/dot_product_with_ortho'
    ]
})


function common (q, params) {

    let vectors = dotProductCommons.vectors(params)

    dotProductCommons.displayVectors(q, vectors, params)

    dotProductCommons.question(q, vectors)

}


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(2, 4, {name: 'ux'}),
            uY: 0,
            vX: random.fairChoiceInt(2, 5, {name: 'vx'}) * random.fairChoice([-1, 1], {name: 'sign'}),
            vY: random.fairChoiceInt(1, 5, {name: 'vy'}),
            angle: random.fairChoice([30, 140, -50], {name: 'angle'})
        })
    },
    times: 2
})



level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(2, 7, {name: 'ux'}),
            uY: 0,
            vX: 0,
            vY: random.fairChoiceInt(2, 7, {name: 'vy'}) * random.fairChoice([-1, 1], {name: 'sign'}),
            angle: random.fairChoice([30, 140, -50], {name: 'angle'})
        })
    },
    times: 2
})


export default level

